import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { computed, Injectable, signal } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MediaService {

    activeMedias = signal<string[]>([]);


    isXSmall = computed(() => {
        return this.activeMedias().includes(Breakpoints.XSmall);
    });
    isSmall = computed(() => {
        return this.activeMedias().includes(Breakpoints.Small);
    });
    isMedium = computed(() => {
        return this.activeMedias().includes(Breakpoints.Medium);
    });
    isLarge = computed(() => {
        return this.activeMedias().includes(Breakpoints.Large);
    });
    isXLarge = computed(() => {
        return this.activeMedias().includes(Breakpoints.XLarge);
    });

    isLESmall = computed(() => {
        return this.activeMedias().includes(Breakpoints.Small) || this.activeMedias().includes(Breakpoints.XSmall);
    });
    isLEMedium = computed(() => {
        return this.activeMedias().includes(Breakpoints.Medium) || this.activeMedias().includes(Breakpoints.Small) || this.activeMedias().includes(Breakpoints.XSmall);
    });
    isLELarge = computed(() => {
        return this.activeMedias().includes(Breakpoints.Large) || this.activeMedias().includes(Breakpoints.Medium) || this.activeMedias().includes(Breakpoints.Small) || this.activeMedias().includes(Breakpoints.XSmall);
    });

    isGESmall = computed(() => {
        return this.activeMedias().includes(Breakpoints.XLarge) || this.activeMedias().includes(Breakpoints.Large) || this.activeMedias().includes(Breakpoints.Medium) || this.activeMedias().includes(Breakpoints.Small);
    });
    isGEMedium = computed(() => {
        return this.activeMedias().includes(Breakpoints.XLarge) || this.activeMedias().includes(Breakpoints.Large) || this.activeMedias().includes(Breakpoints.Medium);
    });
    isGELarge = computed(() => {
        return this.activeMedias().includes(Breakpoints.Large) || this.activeMedias().includes(Breakpoints.XLarge);
    });

    mediaObserver: MediaObserver;

    constructor(breakPoint: BreakpointObserver) {
        breakPoint.observe([Breakpoints.Large, Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall]).pipe(filter(bp => bp.matches)).subscribe(breakpointState => {
            console.log(`Media layout changed => `, breakpointState.breakpoints);
            this.activeMedias.set(Object.keys(breakpointState.breakpoints).filter(media => breakpointState.breakpoints[media]));
        });
    }

}
